// ============================================================================
// GERMAN TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// Geistliche Schätze aus dem Wort Gottes

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "Göttliche Weisheit ist keine abstrakte Theorie, sondern konkretes Leben, das sich in unseren täglichen Entscheidungen zeigt",
    reference: "Sprüche 3:13-18",
    category: "weisheit",
    strongNumbers: {
      "Weisheit": "H2451", // חָכְמָה (chokmah) = praktische Weisheit
      "Verstand": "H8394" // תְּבוּנָה (tebunah) = Einsicht
    },
    reflection: "Wie kann ich göttliche Weisheit heute in meinen Entscheidungen anwenden?"
  },
  {
    type: "tresor_divine",
    content: "Gottes Liebe ist nicht an unsere Verdienste gebunden, sondern ein ewiges Geschenk, das aus Seiner Natur selbst fließt",
    reference: "Römer 8:38-39",
    category: "liebe",
    strongNumbers: {
      "Liebe": "G26", // ἀγάπη (agape) = bedingungslose Liebe
      "scheiden": "G5563" // χωρίζω (chorizo) = trennen
    },
    reflection: "Nichts kann uns von der Liebe Gottes trennen, die in Christus offenbart ist"
  },
  {
    type: "lumiere_vie",
    content: "Jesus ist das Licht, das nicht nur unseren Weg, sondern auch unser inneres Sein erleuchtet",
    reference: "Johannes 8:12",
    category: "identität",
    strongNumbers: {
      "Licht": "G5457", // φῶς (phos) = Licht
      "Leben": "G2222" // ζωή (zoe) = reiches Leben
    },
    reflection: "Wie lasse ich Christi Licht meine Bereiche der Dunkelheit erhellen?"
  },
  {
    type: "force_divine",
    content: "Unsere Kraft kommt nicht aus uns selbst, sondern von dem, der in uns wohnt",
    reference: "Epheser 3:16-17",
    category: "kraft",
    strongNumbers: {
      "gestärkt": "G2901", // κραταιόω (krataioo) = stärken
      "Kraft": "G1411" // δύναμις (dynamis) = göttliche Kraft
    },
    reflection: "Vertraue ich in meinen Schwächemomenten auf Gottes Kraft?"
  },
  {
    type: "paix_profonde",
    content: "Gottes Friede hängt nicht von äußeren Umständen ab, sondern von Seiner beständigen Gegenwart in unseren Herzen",
    reference: "Philipper 4:6-7",
    category: "gelassenheit",
    strongNumbers: {
      "Friede": "G1515", // εἰρήνη (eirene) = vollständiger Friede
      "bewahren": "G5432" // φρουρέω (phroureo) = wie eine Festung bewachen
    },
    reflection: "Wie pflege ich den Frieden Gottes, der allen Verstand übersteigt?"
  },
  {
    type: "esperance_vivante",
    content: "Unsere Hoffnung ist kein unsicherer Wunsch, sondern ein fester Anker, gegründet auf Gottes treuen Verheißungen",
    reference: "Hebräer 6:19",
    category: "hoffnung",
    strongNumbers: {
      "Hoffnung": "G1680", // ἐλπίς (elpis) = zuversichtliche Hoffnung
      "Anker": "G45" // ἄγκυρα (ankyra) = Anker der Seele
    },
    reflection: "In welchen Verheißungen Gottes verankere ich heute meine Hoffnung?"
  },
  {
    type: "transformation",
    content: "Geistliche Verwandlung ist ein fortlaufender Prozess, in dem wir jeden Tag mehr zum Bild Christi werden",
    reference: "2. Korinther 3:18",
    category: "wachstum",
    strongNumbers: {
      "verwandelt": "G3339", // μεταμορφόω (metamorphoo) = vollständig verwandeln
      "Herrlichkeit": "G1391" // δόξα (doxa) = göttliche Herrlichkeit
    },
    reflection: "Welche Bereiche meines Lebens brauchen heute Verwandlung?"
  }
];

export default bibleTreasures;
